import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFocusAuto"><Path d="M3.75 8V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H8M3.75 16V17.25C3.75 18.9069 5.09315 20.25 6.75 20.25H8M16 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V8M20.25 16V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H16M14 13.4L12 9L10 13.4M14 13.4L14.75 15.05M14 13.4H10M10 13.4L9.25 15.05" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFocusAuto;
